/*!
 * Copyright (c) Microsoft. All rights reserved.
 * Licensed under the MIT license. See LICENSE file in the project.
 */
export const DISPLAY_NAME = 53
export const DESCRIPTION = 83
export const UNITS = 53
export const DATA_TYPE = 53
export const DATA_NATURE = 53
export const NAME = 36
export const STATS_WRAPPER = 91
export const MAPPING_WRAPPER = 61
export const MAPPING_FIELD = 32
export const FIELD_PADDING = 10
// this is for the left-column labels in the table view of the editor
export const LABEL_TOP_PADDING = 18
